import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfFont,
  PdfBrush,
  PdfColor,
  ETextAlign,
  PageGen,
} from '../../pdf/pdf';
import { ILayoutLabelTextGen } from '../layoutLabelText';
import { OptsLabelText } from '../optsLabelText';
import { GUtil } from '../../pdf/gutil';
import { IItemCount } from '@educraft/base';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/label';
import '../../pdf/draw/cut';

/**
 * Inicialy__3 - Color Splash letter with word
 *
 * Layout: Multiple portrait pages, 2×5 grid per page.
 * Each cell: Large colorful letter fills the left area, word label on the right.
 * The letter has a bold colored background shape behind it.
 *
 * Creative direction: Letter as an artistic, bold element with strong color presence.
 */
export class Inicialy__3 implements ILayoutLabelTextGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsLabelText): Promise<void> {
    const itemsPerPage = 10;
    const pagesNeeded = Math.ceil(opts.list.length / itemsPerPage);
    const pages: PageGen[] = [];
    for (let i = 0; i < pagesNeeded; i++) {
      pages.push(pdf.addPage());
    }

    const margin = PdfUnit.FromMillimeters(5);
    const cellWidth = PdfSize.A4.width / 2;
    const cellHeight = PdfSize.A4.height / 5;

    const palettes: string[][] = [
      [
        '#FF6B6B',
        '#FF8E53',
        '#FFA502',
        '#FFD93D',
        '#6BCB77',
        '#4D96FF',
        '#9B59B6',
        '#E91E63',
        '#00BCD4',
        '#FF5722',
      ],
      [
        '#A8E6CF',
        '#DCEDC1',
        '#FFD3B6',
        '#FFAAA5',
        '#FF8B94',
        '#FFEAA7',
        '#DDA0DD',
        '#98D8C8',
        '#F7DC6F',
        '#BB8FCE',
      ],
      [
        '#85C1E9',
        '#F8B500',
        '#E74C3C',
        '#27AE60',
        '#9B59B6',
        '#3498DB',
        '#E67E22',
        '#1ABC9C',
        '#F39C12',
        '#8E44AD',
      ],
    ];

    const colors = GUtil.randomBrushes(opts.data.random, palettes);
    const letterFont = new PdfFont(PdfFont.BOLD_FONT_NAME, 120);
    const wordFont = new PdfFont(PdfFont.BOLD_FONT_NAME, 18);

    for (let pageIndex = 0; pageIndex < pagesNeeded; pageIndex++) {
      const page = pages[pageIndex];
      const pageStartIndex = pageIndex * itemsPerPage;

      for (let x = 0; x < 2; x++) {
        for (let y = 0; y < 5; y++) {
          const index = pageStartIndex + x * 5 + y;
          if (index >= opts.list.length) continue;

          const localIndex = x * 5 + y;
          const rect = new PdfRect(x * cellWidth, y * cellHeight, cellWidth, cellHeight);

          const letterAreaWidth = rect.width * 0.55;
          const wordAreaWidth = rect.width * 0.45;

          const letterRect = new PdfRect(rect.x, rect.y, letterAreaWidth, rect.height);
          const wordRect = new PdfRect(
            rect.x + letterAreaWidth,
            rect.y,
            wordAreaWidth,
            rect.height
          );

          const innerMargin = margin * 0.5;
          const letterInnerRect = new PdfRect(
            letterRect.x + innerMargin,
            letterRect.y + innerMargin,
            letterRect.width - 2 * innerMargin,
            letterRect.height - 2 * innerMargin
          );

          const letter = opts.list[index].text.substring(0, 1).toUpperCase();

          page.drawRectangle(null, colors[localIndex], letterRect);
          page.drawLabel(opts.list[index].label, { rect: wordRect });
          page.drawString(
            letter,
            letterFont,
            PdfBrush.White,
            null,
            letterInnerRect,
            ETextAlign.Center
          );
          page.drawRectangle(GUtil.cutPen, null, rect);
        }
      }
    }
  }
}
